import { Link, useNavigate } from "react-router-dom";
import { Button } from "@satyrsmc/shared/components";

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center p-4 md:p-6">
      <div className="text-center">
        <p className="text-6xl font-bold text-muted-foreground">404</p>
        <h1 className="mt-2 text-xl font-semibold">Page not found</h1>
        <p className="mt-2 max-w-sm text-muted-foreground">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Button variant="outline" onClick={() => navigate(-1)}>
            Go back
          </Button>
          <Button asChild>
            <Link to="/">Home</Link>
          </Button>
          <Button asChild variant="secondary">
            <Link to="/login">Login</Link>
          </Button>
        </div>
      </div>
    </main>
  );
}
